import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils/cn';

type Props = { size?: 'sm' | 'md' | 'lg'; className?: string; label?: string };

const SIZES = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-8 w-8' } as const;

export const Spinner = ({ size = 'md', className, label }: Props) => {
  const { t } = useTranslation();
  return (
    <span role="status" aria-label={label ?? t('common.loading')} className={cn('inline-flex', className)}>
      <Loader2 className={cn('animate-spin text-brand-600', SIZES[size])} />
    </span>
  );
};
